import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SellerDetailsRoutingModule } from './seller-details-routing.module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';

import { SellerDetailsComponent } from './seller-details/seller-details.component';
import { SellerDetailsHeaderComponent } from './seller-details-header/seller-details-header.component';
import { SellerDetailsNavbarComponent } from './seller-details-navbar/seller-details-navbar.component';
import { SellerDetailsGeneralComponent } from './seller-details-general/seller-details-general.component';
import { SellerDetailsGeneralInfoComponent } from './seller-details-general-info/seller-details-general-info.component';
import { SellerDetailsGeneralStoresComponent } from './seller-details-general-stores/seller-details-general-stores.component';
import { SellerDetailsEventDataComponent } from './seller-details-event-data/seller-details-event-data.component';

@NgModule({
  declarations: [SellerDetailsComponent, SellerDetailsHeaderComponent, SellerDetailsNavbarComponent, SellerDetailsGeneralComponent, SellerDetailsGeneralInfoComponent, SellerDetailsGeneralStoresComponent, SellerDetailsEventDataComponent],
  imports: [
    CommonModule,
    SellerDetailsRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatTableModule,
  ],
})
export class SellerDetailsModule {}
